import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import routeService from "services/RouteService";
import { useMemo } from "react";
import { FundingAppealFormController } from "components/Pages/Funding/FundingAppealFormController";

const EditAppealNameModalContent: React.FC<{ clubId: string; appealId: string }> = () => {
  const controller = FundingAppealFormController.use();
  const { saving, loading } = controller.state;
  const fields = useMemo(() => Object.values(controller.fields()), [controller]);

  if (loading) return <LoadingModal title="Edit appeal" />;

  return (
    <AppModal title="Edit appeal" className="max-h-[80vh]">
      <Form name="funding_appeal">
        <fieldset disabled={saving}>
          <ModalFormFieldset fields={fields} />
        </fieldset>
        <FormButtons showDelete={false} saveTitle="Save" />
      </Form>
    </AppModal>
  );
};

const EditAppealNameView = FundingAppealFormController.scope(ApplicationView(EditAppealNameModalContent));

export default injectModal((props: { clubId: string; appealId: string }) => (
  <EditAppealNameView {...props} nameOnly onSubmit={async () => routeService.closeModal()} />
));
